/* eslint-disable prettier/prettier */
import Vue from "vue";
import Vuex from "vuex";
import CircleService from "../services/circle";
import InMemoryDb from "../services/inmemorydb";

const circleService = new CircleService();
const InMemoryDatabase = new InMemoryDb();
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    circles: []
  },
  mutations: {
    initializeCircleState(state) {
      state.circles = [];
    },
    addCircle({ circles }, circle) {
      let circleIndexExists = null 
      try { 
        circleIndexExists = circles.findIndex(_circle =>  _circle._id === circle._id);
        if (circleIndexExists && circleIndexExists < 0) {
          circles.push(circle);
        }
      } catch (e) {
        circles.push(circle);
      }
    },
    removeCircle(state, id) {
      state.circles = state.circles.filter(_circle => _circle._id !== id);
    },
    replaceCircle({ circles }, circle) {
      const tempCircles = circles;
      const circleIndex = tempCircles.findIndex(_circle => _circle._id === circle._id);

      if (circleIndex > -1) {
        tempCircles.splice(circleIndex, 1, circle);
        circles = tempCircles;
      } else {
        circles.push(circle);
      }

      InMemoryDatabase.addCircle(circle);
    }
  },
  actions: {
    async fetchCircles({ commit }, profileId) {
      try {
        const circlesFromIndexeddb = await InMemoryDatabase.getCircles();
        circlesFromIndexeddb.map(circle => commit("addCircle", circle));

        circleService.getCurrentUserCircles(profileId).then(circles => {
          commit("initializeCircleState");
          circles.map(circle => {
            const circleType = circle.flags ? circle.flags.find(s => s.type === 'type').value : 'parent';
            if (circleType !== 'child') {
              InMemoryDatabase.addCircle(circle);
              commit("addCircle", circle);
            } else {
              try {
                circle.parent_id = circles.find(s => s.children.find(c => c.child === circle._id))._id;
                InMemoryDatabase.addChildCircle(circle);
              } catch (e) {
                InMemoryDatabase.addCircle(circle);
                commit("addCircle", circle);
              }
            }
          });
        }).catch((e) => { console.log(e) })
      } catch (e) { }
    },
    updateCircle({ commit }, circle) {
      commit("replaceCircle", circle);
    },
    removeCircle({ commit }, id) {
      commit("removeCircle", id);
    },
    addCircle({ commit }, circle) {
      commit("addCircle", circle);
    }
  },
  getters: {
    circleCount: state => (state.circles) ? state.circles.length : 0
  }
});
